import React from "react";

import styles from "./Section3.module.scss";

export const Section3 = function () {
  return (
    <section id="benefits" className={`${styles.section3Wrapper} cc--component-container`}>
      <div className={styles.section3Container}>
        <h3>ON COMPLETION OF THIS PROGRAM, YOU&rsquo;LL WALK AWAY WITH:</h3>
        <div className={styles.section3Content}>
          <div className={styles.firstCol}>
            <span>1</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              A robust <strong>AI decision framework</strong>, helping you understand the considerations
              associated with implementing AI in health care, and equipping you to ask the right questions
              about <strong>AI’s suitability to your context</strong>.
            </p>
          </div>
          <div className={styles.firstCol}>
            <span>2</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              An <strong>awareness of how AI-powered solutions can transform health care</strong>, with opportunities including
              disease diagnosis and monitoring, clinical workflow augmentation, and hospital optimization.
            </p>
          </div>
          <div className={styles.firstCol}>
            <span>3</span>
          </div>
          <div className={styles.secondCol}>
            <p>
              Insights into the various AI-based techniques impacting and improving upon traditional health care structures,
              including <strong>natural language processing, data analytics, and machine learning</strong>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
